'use strict';

(function(global) {

  global.WordCloud.randomColor = function() {
      var colors = ['#b72755', '#0099db', '#958039', '#231f20', '#dc7e22', '#007365', '#a9cf38'];
      var index = Math.floor(Math.random() * colors.length);
      return colors[index];
  };

})(window);
